import {
    useBlockProps,
    useInnerBlocksProps,
} from '@wordpress/block-editor';

/**
 * Save function for the slide block.
 * Outputs outer wrapper + inner content wrapper, matching flow-slide structure.
 * render.php adds Interactivity API directives via tag processor.
 */
export default function save({ attributes }) {
    const { minHeight } = attributes;

    const blockProps = useBlockProps.save({
        className: 'gwx-carousel__slide',
        role: 'tabpanel',
        style: {
            minHeight: minHeight || undefined,
        },
    });

    const innerBlocksProps = useInnerBlocksProps.save({
        className: 'gwx-carousel__slide-content',
    });

    return (
        <div {...blockProps}>
            <div {...innerBlocksProps} />
        </div>
    );
}
